import { FuseRouteConfigType } from '@fuse/utils/FuseUtils';
import authRoles from '../authRoles';
import RecoverChangePasswordPage from './RecoverChangePasswordPage';

const RecoverChangePasswordConfig: FuseRouteConfigType = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: 'recover/change-password',
			element: <RecoverChangePasswordPage />
		}
	]
};

export default RecoverChangePasswordConfig;
